document.addEventListener('alpine:init', () => {
    Alpine.store('GiftUpsellCart', {
        giftVariant: null,
        giftThresholdAmount: 0,
        freeGiftChecked: false,
        disableGiftCheckbox: false,
        async getCurrentCartDetails(){
            let cartDetails = {};
            await $.ajax({
              type: 'GET',
              url: theme.routes.cart_url,
              cache: false,
              dataType: 'json',
              success: function(cart) {
                cartDetails = cart;
              },
              error: function(error) {
                console.log('Error fetching cart details: ', error)
              }
            });
            return cartDetails
        },
        async addFreeGiftToCart(){
            this.disableGiftCheckbox = true;
            try{
              let cartData = {
                "items": [{
                  "id": this.giftVariant,
                  "quantity": 1
                }],
                "sections": "cart-items,cart-footer,cart-item-count"
              }
              const config = fetchConfigDefaults();
              config.body = JSON.stringify(cartData);
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
          
              await fetch(`${theme.routes.cart_add_url}`, config)
                .then((res) => res.json())
                .then((data) => {
                  document.body.dispatchEvent(
                    new CustomEvent('shapes:cart:freegiftadded', {
                    bubbles: true,
                    detail: { response: data },
                    })
                  );
                  this.disableGiftCheckbox = false
                })
            }catch(error){
              console.log('addFreeGiftToCart- Error: ', error)
              this.disableGiftCheckbox = false
            }
        },
        isEligibleForGift(cart){
          if (this.giftVariant){
            const totalPrice = cart.total_price / 100
            const hasFreeGift = cart.items.some(item => item.variant_id === this.giftVariant)
            if (totalPrice >= this.giftThresholdAmount && !hasFreeGift){
              return true
            }
          }
          return false
        },
        async handleFreeGiftUpsell(){
          if (this.freeGiftChecked && theme.settings.enable_gift_upsell){
            const cart = await this.getCurrentCartDetails()
            if (cart){
              if(this.isEligibleForGift(cart)){
                await this.addFreeGiftToCart()
              }
            }
          }
        },
        async cartHasGiftLineItem(){
          const cart = await this.getCurrentCartDetails()
          return cart.items.some(item => item.variant_id === this.giftVariant)
        },
        async removeGiftLineItem(cart){
          const giftLineItem = cart.items.find(item => item.variant_id === this.giftVariant)
          if (giftLineItem){
            const giftLineItemEl = document.querySelector(`li[data-cart-item-key="${giftLineItem.key}"]`)
            const removeBtnEl = giftLineItemEl.querySelector('a.remove-line-item')
            
            if(removeBtnEl){
              //trigger the remove button click event.
              removeBtnEl.click()
            }
          }
        },
        async init() {
            this.giftVariant = theme.settings.gift_upsell_product_variant
            // this.giftVariant = 43994234519707
            this.giftThresholdAmount = theme.settings.gift_upsell_threshold_amount

            if(await this.cartHasGiftLineItem()){
              this.freeGiftChecked = true;
            }


            window.addEventListener('shapes:modalcart:cartqtychange', async (e) => {
              if (theme.settings.enable_gift_upsell){
                const items_removed = e.detail.response.items_removed;
                if(items_removed.length > 0){
                  const isFreeGiftRemoved = items_removed.some(item => item.variant_id === this.giftVariant)
                  // check if gift item is being removed.
                  if(isFreeGiftRemoved){
                    this.freeGiftChecked = false; // un-check the gift checkbox.
                  }else{
                    const cart = await this.getCurrentCartDetails()
                    if(cart){
                      const totalPrice = cart.total_price / 100
                      const hasFreeGift = cart.items.some(item => item.variant_id === this.giftVariant)
                      if(totalPrice < this.giftThresholdAmount && hasFreeGift){
                        this.removeGiftLineItem(cart)
                      }
                    }
                  }
                }
              }

            });
        }
    });
  });